
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30.2 30.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15.068","cy":"15.068","r":"15.068","fill":"#21245c"}}),_c('path',{attrs:{"fill":"#fff","d":"M4.931 14.657c0-2 1.2-3.8 3.3-3.8s3.4 1.8 3.4 3.8-1.2 3.8-3.3 3.8-3.4-1.7-3.4-3.8zm5.3 0c0-1.4-.7-2.5-2-2.5s-2 1.1-2 2.5.7 2.5 2 2.5 2-1.1 2-2.5zM17.431 17.057c.4-.1.7.2.8.5s-.2.7-.5.8H13.931c-.4 0-.7-.2-.7-.6v-6.1c0-.4.2-.7.6-.7h3.5c.4 0 .7.2.7.6 0 .4-.2.7-.6.7h-2.9v1.6h1.6c.4 0 .7.2.7.6 0 .3-.2.6-.5.7h-1.7v1.8l2.8.1zM20.931 17.657c.1.4-.2.7-.6.8-.4.1-.7-.2-.8-.6v-.1-6.1c0-.4.2-.7.6-.7h2.1c1.3-.2 2.4.7 2.6 2v.3c.1.9-.5 1.7-1.3 2l1.1 1.8c.1.2.2.4.2.6 0 .3-.3.6-.6.6h-.1c-.4 0-.5-.2-.7-.6l-1.2-2h-1.3v2zm1.3-3.3c.8 0 1.2-.4 1.2-1s-.5-1-1.2-1h-1.3v2.1l1.3-.1z"}})])
          )
        }
      }
    